exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#givingBackText{\n    text-align: center;\n    padding: 90px 40px 90px 40px;\n    margin: auto;\n    color: #646161;\n    font-size: 16px;\n    letter-spacing: 1px;\n    line-height: 25px;\n    min-height: 50%;\n}\n", ""]);

// exports
